import { CapabilitiesBento } from "@/components/CapabilitiesBento";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Reveal } from "@/components/Reveal";

const FOUR_CS = [
  { c: "Cut", body: "The only C shaped entirely by hand. We grade make, symmetry, and light return — not just the report line.", detail: "Ideal · Excellent · Very Good" },
  { c: "Color", body: "From icy D through warm K, plus fancy yellows, pinks, blues, champagne and cognac on request.", detail: "D — K + fancies" },
  { c: "Clarity", body: "FL to SI2, always eye-checked. An SI1 that faces up clean beats a VS2 that doesn't — we tell you which.", detail: "FL · IF · VVS · VS · SI" },
  { c: "Carat", body: "Calibrated melee to 15-carat statements, single stones or matched parcels and layouts.", detail: "0.30 — 15.00ct+" },
];

const PROCESS = [
  { num: "01", title: "Brief", body: "Send the 4Cs, budget position, and timeline. Cert preference, fluorescence tolerance, delivery port — the more precise, the sharper the search." },
  { num: "02", title: "Source", body: "The desk sweeps sight-holders, manufacturers, and bourse partners across Dubai, Mumbai, Antwerp, and Hong Kong." },
  { num: "03", title: "Verify", body: "Report numbers checked against lab databases, inscriptions matched, origin screened. Nothing is quoted unverified." },
  { num: "04", title: "Deliver", body: "Fully insured carriage to your door, or held in bonded JLT vaulting for memo and call-off." },
];

export const CapabilitiesPage = () => (
  <div className="pt-24" data-testid="capabilities-page">
    <header className="mx-auto max-w-7xl px-6 pb-8 pt-16 lg:px-12">
      <Reveal>
        <p className="eyebrow mb-4">Capabilities</p>
        <h1 className="font-display max-w-3xl text-4xl font-light leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
          What the desk <span className="gold-text italic">can source</span>
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#B8BCC2] sm:text-lg">
          Natural and lab-grown, white and fancy, melee to statement. If it grades, we can find it —
          and if we quote it, we've verified it.
        </p>
      </Reveal>
    </header>

    <CapabilitiesBento />
    <EditorialMarquee />

    <section className="mx-auto max-w-7xl px-6 py-24 lg:px-12" data-testid="four-cs">
      <Reveal>
        <p className="eyebrow mb-4">The 4Cs, as we read them</p>
        <h2 className="font-display max-w-2xl text-3xl font-light text-white sm:text-4xl">
          Grading is the start. <span className="gold-text italic">Judgment is the job.</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid gap-6 sm:grid-cols-2">
        {FOUR_CS.map((f, i) => (
          <Reveal key={f.c} delay={i * 0.08}>
            <div className="glass-panel group h-full rounded-2xl p-8 transition-all duration-500 hover:border-[#C9A24B]/40 lg:p-10" data-testid={`four-c-${f.c.toLowerCase()}`}>
              <div className="flex items-baseline justify-between">
                <h3 className="font-display text-3xl font-light text-white">{f.c}</h3>
                <span className="text-[10px] uppercase tracking-[0.2em] text-[#C9A24B]">{f.detail}</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-[#B8BCC2]">{f.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>

    <section className="mx-auto max-w-7xl px-6 pb-28 lg:px-12" data-testid="sourcing-process">
      <Reveal>
        <p className="eyebrow mb-4">How a brief becomes a stone</p>
        <h2 className="font-display max-w-2xl text-3xl font-light text-white sm:text-4xl">The process</h2>
      </Reveal>
      <div className="mt-14 grid gap-6 lg:grid-cols-4">
        {PROCESS.map((p, i) => (
          <Reveal key={p.num} delay={i * 0.08}>
            <div className="hairline relative border-t pt-8" data-testid={`process-${p.num}`}>
              <span className="font-display text-sm italic tracking-[0.3em] text-[#C9A24B]">{p.num}</span>
              <h3 className="font-display mt-3 text-2xl text-white">{p.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#B8BCC2]">{p.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  </div>
);
